export class LocalStorageService<T> {
  constructor(private readonly key: string) {}

  saveData(data: T): void {
    localStorage.setItem(this.key, JSON.stringify(data))
  }

  getData(): T | null {
    const raw = localStorage.getItem(this.key)
    if (!raw) return null
    try {
      return JSON.parse(raw) as T
    } catch {
      return null
    }
  }

  clearData(): void {
    localStorage.removeItem(this.key)
  }
}
